<template>
	<div class="wishlist-count" v-if="state.wishlist.length">{{ state.wishlist.length }}</div>
</template>

<script>
	export default {
		data() {
			return {
				state: this.$store.state
			}
		}
	}
</script>

